/* globals $ */
/* eslint-disable no-underscore-dangle */
import SimpleEventer from 'simple-eventer';

function createClassName(construct) {
  return construct.toString().split('(' || /s+/)[0].split(' ' || /s+/)[1];
}

export default class Component extends SimpleEventer {

  constructor(defaults = {}, options = {}) {
    super();
    this._settings = Object.assign({}, defaults, options);
    this._className = createClassName(this.constructor);
  }

  get settings() {
    return this._settings;
  }

  set settings(options) {
    this._settings = Object.assign({}, this._settings, options);
  }

  static initialize(selector, ClassName, classNameString, $context = $(document.body), options = {}) {
    const instances = [];

    console.log('initializing ' + classNameString);

    $context.find(selector).each((index, element) => {
      if (!element['instance' + classNameString]) {
        const instance = new ClassName($(element), options);

        instances.push(instance);
        element['instance' + classNameString] = instance;
      }
    });

    return instances;
  }

}



// WEBPACK FOOTER //
// ./front/bankomania/js/components/component.js